import type { DirectiveBinding, ObjectDirective, VNode } from 'vue';
import Core from '@/core/core/core';

const $ = (el: VNode) => {
	if (!Core.$?.ui?.tooltip) {
		console.info('Для работы v-top-tooltip требуется глобальная загрузка jQuery UI Tooltip');

		return;
	}

	return Core.$(el);
};

const tvTooltipGenOptions = (binding: DirectiveBinding, vnode: VNode) => {
	const options = binding.value ?? {};

	options.content ??= vnode.props?.title;
	options.content = String(options.content).replace(/\r\n|\r|\n/g, '<br>');

	options.position ??= {
		my: 'bottom-18px',
		at: 'top center',
	};

	return options;
};

/**
 * Добавление всплывающей подсказки к элементу.
 */
const tooltip = {
	mounted(el: VNode, binding: DirectiveBinding, vnode: VNode) {
		$(el)?.tooltip(tvTooltipGenOptions(binding, vnode));
	},

	updated(el: VNode, binding: DirectiveBinding, vnode: VNode, _prevVnode: VNode) {
		/**
		 * В результате обновления может быть открыто несколько тултипов поэтому изменить опции, без перерисовки тултипа
		 */
		const options = tvTooltipGenOptions(binding, vnode);
		const instance = $(el)?.tooltip('instance') as { options: JQueryUI.TooltipOptions } | undefined;
		if (!instance) {
			return;
		}

		instance.options = {
			...instance.options,
			...options,
		};
	},

	unmounted(el: VNode, _binding: DirectiveBinding, _vnode: VNode) {
		$(el)?.tooltip('destroy');
	},
};

export default tooltip;
